import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    redirect: '/login',
    component: () => import('../views/login/Login.vue'),
    children:[
      {
        path: '/login',
        name: 'Login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/login/Login.vue')
      },
    ]
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/login/Register.vue'),
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('../views/login/Forget.vue'),
  },
  {
    path: '/perfect',
    name: 'Perfect',
    component: () => import('../views/login/Perfect.vue'),
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/login/agreement.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/home/Home.vue'),
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/course/course.vue'),
  },
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: () => import('../views/course/courseDetail.vue'),
  },
  {
    path: '/question',
    name: 'question',
    component: () => import('../views/question/question.vue'),
  },
  {
    path: '/personal',
    component: () => import('../views/personal/index.vue'),
    name: 'personal',
    redirect: '/personal/user',
    children: [
      {
        path: '/personal/user',
        name: 'user',
        component: () => import('../views/personal/user.vue'),
      },
      {
        path: '/personal/course',
        name: 'course',
        component: () => import('../views/personal/course.vue'),
      },
      {
        path: '/personal/examination',
        name: 'examination',
        component: () => import('../views/personal/examination.vue'),
      },
      {
        path: '/personal/report',
        name: 'report',
        component: () => import('../views/personal/report.vue'),
      },
      {
        path: '/personal/exercises',
        name: 'exercises',
        component: () => import('../views/personal/exercises.vue'),
      },
      {
        path: '/personal/gradePoint',
        name: 'gradePoint',
        component: () => import('../views/personal/gradePoint.vue'),
      },
      {
        path: '/personal/certificate',
        name: 'certificate',
        component: () => import('../views/personal/certificate.vue'),
      },
      {
        path: '/personal/message',
        name: 'message',
        component: () => import('../views/personal/message.vue'),
      },
      {
        path: '/personal/questions',
        name: 'questions',
        component: () => import('../views/personal/questions.vue'),
      },
    ],
  },
  {
    path: '/examination',
    name: 'examination',
    component: () => import('../views/examination/examination.vue'),
  },
  {
    path: '/examinationDetail',
    name: 'examinationDetail',
    component: () => import('../views/examination/examinationDetail.vue'),
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/examination/report.vue'),
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: () => import('../views/examination/analysis.vue'),
  },
  {
    path: '/exercise/detail',
    name: 'exerciseDetail',
    component: () => import('../views/exercise/detail.vue'),
  },
  {
    path: '/exercise/result',
    name: 'exerciseResult',
    component: () => import('../views/exercise/result.vue'),
  },
  {
    path: '/exercise/report',
    name: 'exerciseReport',
    component: () => import('../views/exercise/report.vue'),
  },
  {
    path: '/exercise/analysis',
    name: 'exerciseAnalysis',
    component: () => import('../views/exercise/analysis.vue'),
  }
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // // 访问登录页，放行
  if (to.path === '/login') return next()

  if(from.name == 'Perfect') return false
  // // 获取token
  // const tokenStr = window.sessionStorage.getItem('token')
  // // 没有token, 强制跳转到登录页
  // if (!tokenStr) return next('/login')
  next()
})

export default router
